// extracted by mini-css-extract-plugin
var _1 = "FaqStyle-module__faqContainer___f5jJU";
var _2 = "FaqStyle-module__faqLabel___ueXgb";
var _3 = "FaqStyle-module__faqWrapper___JWCb4";
export { _1 as "faqContainer", _2 as "faqLabel", _3 as "faqWrapper" }
